import React, { useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faFacebookF } from '@fortawesome/free-brands-svg-icons';
import {
  faStethoscope,
  faChevronDown,
  faChevronUp,
} from '@fortawesome/free-solid-svg-icons';
import { Spinner } from 'react-bootstrap';
import styled from 'styled-components';

import {
  AccContainer,
  Container,
  DivContainer,
  LinksContainer,
  ProgramarCita,
  ServiceContainer,
  SocialMedia,
  StyledLink,
  StyledNavLink,
  Ul,
} from './NavbarPrincipal.elements';
import useConfigs from '../../hooks/useConfigs';
import { fetchListaConfiguracion } from '../../services/parameter.service';
import useThemes from '../../hooks/useThemes';
import { useApi } from '../../hooks/useApi';

const NavbarPrincipal = () => {
  const { opcionesMenu, servicios, getOpcionesMenu } = useApi();
  const { fontSizeMultiplier, activeTheme, changeFontSize } = useConfigs();

  const {
    backgroundWhite,
    backgroundSecundario,
    backgroundBtn,
    backgroundTercero,
    backgroundCuarto,
    colorPrincipal,
    colorSecundario,
    logo,
  } = useThemes();

  const history = useHistory();
  const { push } = useHistory();

  const location = useLocation();

  const [clicked, setClicked] = useState(false);
  const [isFixed, setIsFixed] = useState(false);
  const [doctorFamedic, setDoctorFamedic] = useState(null);
  const [showServices, setShowServices] = useState(false);

  const getUrl = async () => {
    try {
      const response = await fetchListaConfiguracion({
        key: 'URL_DOCTOR_FAMEDIC',
      });
      setDoctorFamedic(response.data.list[0]?.value);
    } catch (error) {
      console.error(error);
    }
  };

  const handleClick = (item) => {
    setClicked((prevState) => !prevState);
    if (item.nombreOpcion === 'Servicios') {
      setShowServices((prevState) => !prevState);
    } else {
      setShowServices(false);
      if (item.nombreOpcion === 'TELEMEDICINA') {
        window.open(doctorFamedic, '_blank');
      }
    }
  };

  const handleClickItem = (item) => {
    setShowServices((prevState) => !prevState);

    if (item.nombreOpcion === 'Citas y turnos') {
      window.open(doctorFamedic, '_blank');
    } else {
      push({ pathname: '/servicio-detalle', state: item });
      // history.push(item.rutaOpcion);
    }
  };

  useEffect(() => {
    getUrl();
  }, []);

  window.onscroll = function () {
    window.scrollY > 36 ? setIsFixed(true) : setIsFixed(false);
  };

  useEffect(() => {
    getOpcionesMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container isfixed={isFixed}>
      <DivContainer
        isfixed={isFixed}
        fontsizemultiplier={fontSizeMultiplier}
        tema={activeTheme}
        backgroundcolor={backgroundWhite}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div className='menu' onClick={handleClick}>
            {!clicked ? (
              <img
                style={{ width: '50px' }}
                src='img/Iconos/SVG/menu.svg'
                alt='menu'
              />
            ) : (
              <img
                style={{ width: '50px' }}
                src='img/Iconos/SVG/cerrar.svg'
                alt='cerrar'
              />
            )}
          </div>

          <Link to='/'>
            {opcionesMenu.isLoading ? (
              <div className='spinner'>
                <Spinner
                  animation='grow'
                  style={{ marginRight: '1rem' }}
                  variant='secondary'
                />
                <Spinner
                  animation='grow'
                  style={{ marginRight: '1rem' }}
                  variant='secondary'
                />
                <Spinner
                  animation='grow'
                  style={{ marginRight: '1rem' }}
                  variant='secondary'
                />
              </div>
            ) : (
              <img className='logo' src={logo} alt='Famedic IPS' />
            )}
          </Link>
        </div>

        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div
            className={`links ${clicked ? 'active' : ''}`}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            {opcionesMenu.isLoading ? (
              <div className='spinner'>
                <Spinner
                  animation='grow'
                  style={{ marginRight: '1rem' }}
                  variant='secondary'
                />
                <Spinner
                  animation='grow'
                  style={{ marginRight: '1rem' }}
                  variant='secondary'
                />
                <Spinner
                  animation='grow'
                  style={{ marginRight: '1rem' }}
                  variant='secondary'
                />
              </div>
            ) : (
              <Ul
                backgroundcolor={backgroundSecundario}
                btnbackground={backgroundBtn}
                active={activeTheme}
              >
                {opcionesMenu.data.principal
                  .sort((a, b) => a.id - b.id)
                  // .filter((item) => item.nombreOpcion !== "SEDES")
                  .map((item) => (
                    <li key={item.id}>
                      <StyledNavLink
                        onClick={() => handleClick(item)}
                        color={colorPrincipal}
                        name={item.nombreOpcion}
                        fontsizemultiplier={fontSizeMultiplier}
                        to={
                          item.nombreOpcion === 'Servicios'
                            ? window.screen.width < 1023
                              ? item.rutaOpcion
                              : location.pathname
                            : item.rutaOpcion
                        }
                        // to={item.rutaOpcion}
                      >
                        {item.nombreOpcion === 'SEDES' && (
                          <img
                            style={{
                              width: 50 * fontSizeMultiplier,
                            }}
                            src='img/Iconos/SVG/Sedes.svg'
                            alt='sedes'
                          />
                        )}
                        {item.nombreOpcion}
                        {item.nombreOpcion === 'Servicios' && (
                          <FontAwesomeIcon
                            style={{ marginLeft: '0.5rem' }}
                            icon={showServices ? faChevronUp : faChevronDown}
                            color={colorPrincipal}
                          />
                        )}
                      </StyledNavLink>
                    </li>
                  ))}

                <div className='secondary-navbar'>
                  <div className='accesibilidad'>
                    <AccContainer>
                      <button
                        className='button'
                        onClick={() =>
                          changeFontSize(fontSizeMultiplier - 0.125)
                        }
                      >
                        -
                      </button>
                      <p>Aa</p>
                      <button
                        className='button'
                        onClick={() =>
                          changeFontSize(fontSizeMultiplier + 0.125)
                        }
                      >
                        +
                      </button>
                    </AccContainer>
                  </div>

                  <LinksContainer>
                    {opcionesMenu.data.secundario.map((item) => (
                      <StyledLink
                        onClick={() => {
                          handleClick(item);
                        }}
                        key={item.id}
                        to={item.rutaOpcion}
                      >
                        {item.nombreOpcion}
                      </StyledLink>
                    ))}
                  </LinksContainer>

                  <SocialMedia>
                    <a
                      className='twitter'
                      href='https://www.twitter.com'
                      target='_blank'
                      rel='noreferrer'
                    >
                      <FontAwesomeIcon
                        icon={faTwitter}
                        color='#fff'
                        size='2x'
                      />
                    </a>
                    <a
                      className='facebook'
                      href='https://www.facebook.com'
                      target='_blank'
                      rel='noreferrer'
                    >
                      <FontAwesomeIcon
                        icon={faFacebookF}
                        color='#fff'
                        size='2x'
                      />
                    </a>
                  </SocialMedia>
                </div>
              </Ul>
            )}
          </div>

          {/* <LupaContainer fontsizemultiplier={fontSizeMultiplier}>
            <img src="img/Iconos/SVG/lupa.svg" alt="lupa" />
          </LupaContainer> */}

          <ProgramarCita
            fontsizemultiplier={fontSizeMultiplier}
            backgroundcolor={backgroundTercero}
            color={colorSecundario}
            onClick={() => history.push('/doctorfamedic')}
          >
            <FontAwesomeIcon
              icon={faStethoscope}
              color={colorSecundario}
              size='2x'
            />
            <p>
              programar
              <br />
              cita
            </p>
          </ProgramarCita>
        </div>
      </DivContainer>
      {showServices && (
        <div style={{ position: 'relative' }}>
          <ServiceContainer
            backgroundcolor={backgroundWhite}
            color={colorPrincipal}
            fontsizemultiplier={fontSizeMultiplier}
            itembackground={backgroundCuarto}
          >
            <div className='item-container'>
              {servicios.data.map((item) => (
                <div
                  key={item.name}
                  className='item'
                  onClick={() => handleClickItem(item)}
                >
                  <p>{item.nombreOpcion}</p>
                </div>
              ))}
            </div>
            {/* <SubmitButton
              type='button'
              label='Ver todo'
              onClick={() => {
                history.push('/services');
                setShowServices((prevState) => !prevState);
              }}
            /> */}
            <CustomButton
            onClick={() => {
              history.push('/services')
              setShowServices((prevState) => !prevState);
            }}
          >
            Ver todo
          </CustomButton>
          </ServiceContainer>
        </div>
      )}
    </Container>
  );
};

export default NavbarPrincipal;


const CustomButton = styled.a`
  background-color: #04AAAA;
  color: #fff;
  font-size: ${(props) => 16 * props.fontsizemultiplier};
  border: 1px solid;
  padding: 1rem 10rem;
  margin-bottom: 2rem;
  border-radius: 100px;
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;

  &:hover,
  &:focus {
    text-decoration: none;
    filter: brightness(1.1);
    color: #fff;
  }
`;